export default "__VITE_ASSET__tzMWcTRC__"